// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"e13b8695","538":"08a7a11f","793":"9e296d49","940":"99c68ea9"}[chunkId] + ".chunk.js";
};